export default {
  'groups.list.header.description': 'Group description',
  'groups.list.header.area': 'Area',
  'groups.list.header.actions': 'Actions',
  'groups.list.column.actions.button': 'View/Edit',
  'groups.searchBar.button.generateReport': 'Generate Report',
  'groups.searchBar.button.newGroup': 'New Group',
  'groups.general.form.description': 'Group Description',
  'subGroups.general.form.description': 'SubGroup Description',
  'groups.general.form.area': 'Area',
  'groups.general.form.subGroup': 'Sub Group',
  'groups.general.form.subGroupRemove': 'Remove Sub Group',
  'groups.general.form.subGroupAdd': 'Add Sub Group',
  'groups.general.form.save': 'Save',
  'groups.general.form.removeGroup': 'Remove Group',
  'groups.create.notification.success': 'Success',
  'groups.create.notification.successDescription': 'Group created.',
  'groups.remove.modal.title': 'Do you really want to delete the group?',
  'groups.remove.modal.content': `
    When deleting the group, all sub-groups associated with it will be removed.
    This action cannot be reversed.
  `,
  'groups.remove.modal.button.ok': 'Remove',
  'groups.remove.notification.success': 'Success',
  'groups.remove.notification.successDescription': 'Grupo deleted.',
  'groups.subgroups': 'Sub-Groups',
  'groups.subgroups.create': 'Create New Sub-Group',
  'groups.subgroups.create.notification.success': 'Success',
  'groups.subgroups.create.notification.successDescription':
    'Sub-Group created.',
  'groups.subgroups.update': 'Update Sub-Group',
  'groups.subgroups.update.notification.success': 'Success',
  'groups.subgroups.update.notification.successDescription':
    'Sub-Group updated.',
  'groups.subgroups.remove.modal.title': 'Remove Sub-Group',
  'groups.subgroups.remove.modal.content':
    'Do you want to remove the sub-group?',
  'groups.subgroups.remove.modal.button.ok': 'Remove',
  'groups.subgroups.remove.modal.message.success':
    'Sub-Group successfully removed!',
  'groups.subgroups.remove.modal.message.error': 'Unable to remove sub-group!',
  'groups.subgroups.remove.notification.success': 'Success',
  'groups.subgroups.remove.notification.successDescription':
    'Sub-Group deleted.',
  'groups.update.notification.success': 'Group updated successfully!',
  'groups.update.notification.successDescription':
    'Group information has been updated.',

  'groups.modal.report.title': 'Generate Report',
  'groups.modal.report.buttons.viewReport': 'View Report',
  'groups.modal.report.buttons.pdf': 'Generate PDF',
  'groups.modal.report.buttons.rtf': 'Generate RTF',
  'groups.modal.report.buttons.csv': 'Generate CSV',
  'groups.modal.report.form.description': 'Description',
  'groups.modal.report..form.areas': 'Areas',
  'groups.notification.generate.report.title': 'Report Generated Successfully',
  'groups.notification.generate.report.description':
    'Inventory Report by Groups Generated Successfully!',

  'groups.error.remove.bonds':
    'The action could not be completed due to a violation of the links for this record!',
  'groups.subGroups.error.remove.bonds':
    'The action could not be completed due to a violation of the links for this record!',

  'groups.status.message.success': 'Status do Grupo alterado com sucesso!',
};
